import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueTree from '@ssthouse/vue-tree-chart'
import Vue from 'vue'


// Flat Pickr (https://github.com/ankurk91/vue-flatpickr-component/blob/master/examples/App.vue)
Vue.component(FeatherIcon.name, FeatherIcon)
// Vue Font Awesome (https://github.com/FortAwesome/vue-fontawesome)
Vue.component('FontAwesomeIcon', FontAwesomeIcon)
// Solid <font-awesome-icon :icon="['fas', 'user-secret']" />
// Brand <font-awesome-icon :icon="['fab', 'font-awesome']" />
// Regular <font-awesome-icon :icon="['far', 'user-secret']" />
// Light <font-awesome-icon :icon="['fal', 'user-secret']" />
// Duotone <font-awesome-icon :icon="['fad', 'user-secret']" />
// Vue Tree Chart (https://github.com/ssthouse/vue-tree-chart)
Vue.component('VueTree', VueTree)
export {
    FeatherIcon,
    VueTree,
    FontAwesomeIcon,
}
